import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import ReferenceItems from '/@/components/map/reference-items';
import Popup from '/@/components/popup';
import styles from './styles.module.css';

/** @param {typeof propTypes} props  */
function ExtraInformation({ onClose, visible, referenceItems, information }) {
    const getSections = (text) => {
        return text.replace(/\r/gm, '').split('## ').filter(Boolean);
    };

    const getParagraphs = (text) => {
        return text.replace(/\n+/gm, '\n').split('\n').filter(Boolean);
    };

    return (
        <Popup stretch onClose={onClose} visible={visible}>
            <div className={styles.root}>
                <Fragment>
                    {getSections(information).map((section) => (
                        <div key={section} className={styles.section}>
                            {getParagraphs(section).map((paragraph, paragraphIndex) => (
                                <p key={paragraph} className={classNames({ [styles.title]: paragraphIndex === 0 })}>
                                    {paragraph}
                                </p>
                            ))}
                        </div>
                    ))}
                </Fragment>
                <ReferenceItems stacked items={referenceItems} />
            </div>
        </Popup>
    );
}

const propTypes = {
    information: PropTypes.string.isRequired,
    referenceItems: PropTypes.array.isRequired,
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

ExtraInformation.propTypes = propTypes;

export default ExtraInformation;
